import { useState, useCallback, useEffect } from 'react';
import useNavigationGuard from '@util/hook/useNavigationGuard';

/**
 * useConditionalNavigationGuard
 * 依條件攔截導航，並將攔截後的行為（dialog 等）交由呼叫方決定
 *
 * @param {Object} config
 * @param {boolean} config.isConditionMet 目前是否符合條件（例如專注模式是否開啟）
 * @param {Function} config.onNavigationBlocked 攔截到返回時的回呼，接收 { isConditionMet, confirmNavigation, cancelNavigation }
 * @param {boolean} config.defaultEnabled 初始是否啟用守衛
 */
const useConditionalNavigationGuard = ({ isConditionMet, onNavigationBlocked, defaultEnabled = true }) => {
    const [isGuardEnabled, setGuardEnabled] = useState(defaultEnabled);

    const { navigationKey, confirmNavigation, cancelNavigation } = useNavigationGuard({
        isGuardEnabled,
    });

    const handleNavigationBlocked = useCallback(
        () => {
            onNavigationBlocked({ isConditionMet, confirmNavigation, cancelNavigation });
        },
        // eslint-disable-next-line
        [isConditionMet],
    );

    // 攔截到返回時，觸發呼叫方提供的行為
    useEffect(
        () => {
            if (navigationKey) {
                handleNavigationBlocked();
            }
        },
        // eslint-disable-next-line
        [navigationKey, handleNavigationBlocked],
    );

    // 條件成立時，自動補回導航守衛
    useEffect(
        () => {
            if (!isGuardEnabled && isConditionMet) {
                setGuardEnabled(isConditionMet);
            }
        },
        // eslint-disable-next-line
        [isConditionMet],
    );

    return { setGuardEnabled };
};

export default useConditionalNavigationGuard;
